import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertNumberToWord'
})
export class ConvertNumberToWordPipe implements PipeTransform {
  private ones: string[] = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  private teens: string[] = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  private tens: string[] = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  transform(value: number): string {
    if (value < 0 || value > 99) {
      return value.toString(); // or throw an error if you prefer
    }
    if (value === 0) return 'zero';
    if (value > 0 && value < 10) return this.ones[value];
    if (value > 10 && value < 20) return this.teens[value - 11];
    if (value % 10 === 0) return this.tens[Math.floor(value / 10)];
    return this.tens[Math.floor(value / 10)] + '-' + this.ones[value % 10];
  }

}
